import {AfterContentInit, Directive, Injector, Input, OnDestroy} from "@angular/core";
import {AbstractSelectColumnComponent} from "./abstract-select-column.component";
import {EntityData} from "@fedeltapointofsale/data-client";
import {FormGroup} from "@angular/forms";

@Directive()
export class AbstractMultiSelectColumnComponent extends AbstractSelectColumnComponent implements AfterContentInit, OnDestroy {
    @Input() cellClassGetter: (this: void, formGroup: FormGroup, dataItem: any) => any;
    @Input() multiObjectValueType: boolean;
    @Input() viewFilter: (item: any) => boolean;
    @Input() hidePlaceHolderOnCell: boolean;

    constructor(injector: Injector, valueField?: string, labelField?: string, protected i18nLabelPrefix?: string) {
        super(injector, valueField, labelField);
    }

    getCellSummary(entity: EntityData<any>): string {
        const collection: any[] = EntityData.getField(entity, this.field);
        if (collection == undefined || collection.length === 0) {
            if (this.hidePlaceHolderOnCell) {
                return " ";
            } else {
                const placeholder: string = this.getPlaceholder(entity);
                return placeholder ? this.translateService.instant(placeholder) : undefined;
            }
        }
        let summary: string = undefined;
        collection.forEach((value: any) => {
            if (this.data && this.data.length) {
                const option: any = this.data.find(o => o[this.valueField] === value);
                if (option && (!this.viewFilter || this.viewFilter(option))) {
                    summary = (summary ? summary + ", " : "") + option[this.labelField];
                }
            } else if ((!this.viewFilter || this.viewFilter(value))) {
                if (this.i18nLabelPrefix) {
                    summary = (summary ? summary + ", " : "") + this.translateService.instant(this.i18nLabelPrefix + value);
                } else if (this.labelField && value[this.labelField]) {
                    summary = (summary ? summary + ", " : "") + value[this.labelField];
                }
            }
        });
        return summary;
    }
}
